import theme from "@/packages/theme/theme";
import { Button } from "@chakra-ui/react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FLEX } from "@styles/common";
import type { ButtonProps } from "./button.type";

export const sizeCSS = {
    large: css`
        height: 56px;
        padding: 0 48px;
        column-gap: 8px;
    `,
    mediumLarge: css`
        height: 40px;
        padding: 0 48px;
        column-gap: 8px;
    `,

    medium: css`
        width: 144px;

        column-gap: 8px;
    `,

    small: css`
        height: 36px;
        font-size: 14px;
        column-gap: 8px;
    `,

    tiny: css`
        padding: 0 8px;
        height: 22px;
        font-size: 14px;
        column-gap: 4px;
    `,
};

export const borderCSS = {
    default: css`
        border: 1px solid ${theme.COLORS.black};
    `,
    navy: css`
        border: 1px solid #3b6c8d;
    `,
    none: css`
        border: none;
    `,
};

export const roundCSS = {
    default: css`
        border-radius: 8px;
    `,

    none: css`
        border-radius: 0px;
    `,

    pill: css`
        border-radius: 999px;
    `,

    full: css`
        border-radius: 50%;
    `,
};

export const backgroundCSS = {
    default: css`
        background: none;
    `,
    navy: css`
        background: #3b6c8d;
        color: #fff;
        :hover {
            background: #3b6c8d;
        }
    `,
};
export const StyledButton = styled(Button)<ButtonProps>`
    ${FLEX.normal("center", "center")}
    font-weight: 500;
    padding: 0 16px;
    cursor: pointer;
    &:hover {
        background: none;
    }
    width: ${({ w = "100%" }) => w};
    ${({ backgroundType = "default" }) => backgroundCSS[backgroundType]}
    ${({ sizeType = "large" }) => sizeCSS[sizeType]}
    ${({ borderType = "default" }) => borderCSS[borderType]};
    ${({ roundType = "default" }) => roundCSS[roundType]}
`;
